module.exports = __webpack_public_path__ + "static/img/UA@3x.09f41fb3.jpg";